<template>

<v-dialog v-model="dialog" width="800px">
  <v-card>
    <v-form ref="manualBkmt" v-model="manualBkmt1Valid">
    <p class=".title ma-2"></p>


    <v-row v-if="! step2" no-gutters>
      <v-col class="mx-2">
        <v-text-field v-model="huov_code" label="Rental Contract number"  :rules="[numberRule]"></v-text-field>
      </v-col>
    </v-row>

    <div v-if="step2">

      <v-radio-group  v-model="select_value">



    
    <div v-for="(selectRecord,i) in huov.select" :key="i">
      <v-row no-gutters>
        <v-col cols=1>
          <v-radio :value=selectRecord.select_value> </v-radio>
        </v-col>  
        <v-col cols="11">
          <v-row no-gutters>
            <v-col>
              {{selectRecord.select_name}}
            </v-col>  
          </v-row>  
           <v-row v-if="selectRecord.select_term1 != null" no-gutters>
            <v-col cols="2">
               Payment term 1
            </v-col>
            <v-col cols="2" align="right" :class=selectRecord.select_term1_kleur>
               {{selectRecord.select_term1}}
            </v-col>   
          </v-row>
          <v-row v-if="selectRecord.select_term2 != null" no-gutters>
            <v-col cols="2">
               Payment term 2
            </v-col>
            <v-col cols="2" align="right" :class=selectRecord.select_term2_kleur>
               {{selectRecord.select_term2}}
            </v-col>   
          </v-row>
          <v-row v-if="selectRecord.select_saldo != null" no-gutters>
            <v-col cols="2">
               Outstanding
            </v-col>
            <v-col cols="2" align="right" :class=selectRecord.select_saldo_kleur>
               {{selectRecord.select_saldo}}
            </v-col>   
          </v-row>
        </v-col>  
      </v-row>        
    </div>  
    
      
    <!--
    <table>
      <tr v-for="(selectRecord,i) in huov.select" :key="i">
        <td><v-radio :value=selectRecord.select_value></v-radio></td>
        <td>{{selectRecord.select_name}}</td>
        <td>{{selectRecord.select_term1}}</td>
        <td>{{selectRecord.select_term2}}</td>
      </tr>  
    </table>    
    -->
  
    <!--
    <v-row v-for="(selectRecord,i) in huov.select" :key="i"   no-gutters>
       <v-col cols="1" class="mx-2">
           <v-radio :value=selectRecord.select_value></v-radio>
       </v-col>  
       <v-col cols="4" class="mx-2">
           {{selectRecord.select_name}}
       </v-col>
       <v-col cols="4" class="mx-2">
           {{selectRecord.select_term1}}
       </v-col>
       <v-col cols="4" class="mx-2">
           {{selectRecord.select_term2}}
       </v-col>
    </v-row>  
    -->

    </v-radio-group>
      

    </div>
   
 
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn v-if="!step2" class="primary mx-2" :disabled="!manualBkmt1Valid" small @click="getHuov">get Booking</v-btn>
      <v-btn v-if="step2" class="primary mx-2"  small @click="savePayment">Save Payment</v-btn>
      <v-btn color="primary"  small @click="dialog = false; step2 = false;">Close</v-btn>
    </v-card-actions>
    </v-form>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      manualBkmt1Valid: false,
      huov: {},
      select_value: null,
      step2: false,
      huov_code: '',
      rules: [v => v.length <= 9 || 'Max 9 characters'],
      numberRule: v  => {
        if (!v.trim()) return true;
        if (!isNaN(parseFloat(v)) && v >= 100000000 && v <= 299999999) return true;
        return 'Number has to be between 1000000000 and 199999999';
      }
    }
  },
  methods: {
    open(bkmt_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/task/fin/abn/bkmt/getBkmt.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getBkmt"
          },
          getBkmt: {
            bkmt_encrid: bkmt_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.bkmt = res.data.getBkmt;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getHuov() { 
      this.$axios
        .post("ares/json/ares/task/fin/abn/bkmt/getHuov.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuov"
          },
          getHuov: {
            bkmt_encrid: this.bkmt.bkmt_encrid,
            huov_code : this.huov_code
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
            this.huov = res.data.getHuov;
             if (res.data.getHuov.color != "success") {  
                 /* setTimeout(() => { this.$router.reload('/task/fin/abn/bkmt/searchBkmt1');  }, 2000);    */                                          
                 this.$store.dispatch('setSnackbar', {
                   showing: true,
                  text: res.data.getHuov.text,
                  color: res.data.getHuov.color
                 }); 
                 this.dialog = false;
             } else this.step2 = true;
          }
        })
    },
    savePayment() { 
      this.$axios
        .post("ares/json/ares/task/fin/abn/bkmt/savePayment.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "savePayment"
          },
          savePayment: {
            bkmt_encrid: this.bkmt.bkmt_encrid,
            huov_code : this.huov_code,
            select_value: this.select_value
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
                if (res.data.savePayment.color == "success") { 
                   setTimeout(() => { this.$router.reload('/task/fin/abn/bkmt/searchBkmt1');  }, 2000);   
                }                                            
                 this.$store.dispatch('setSnackbar', {
                   showing: true,
                  text: res.data.savePayment.text,
                  color: res.data.savePayment.color
                 }); 
                 this.dialog = false;
        
          }
        })
    }
  }
}
</script>

